export const appsetting = {
    // this role on IAM for group admin
    //RoleThisApp: 'arn:aws:iam::017446944980:role/ap-southeast-1_lWomqhl5m-adminGroupRole',
};